import { Grid, Typography } from '@mui/material';
import { PanelBase, PanelBaseType } from '@pages/NewQuote/PanelBase/PanelBase';
import { ITogglePanel } from '@pages/NewQuote/TogglePanel';
import { useStore } from '@store/GlobalStore';
import { useNewQuoteStore } from '@store/NewQuote';
import { shallow } from 'zustand/shallow';

export const NameInsuredClosedPanel = (props: ITogglePanel) => {
  const { onOpen } = props;
  const [{ isCustomerUser }] = useStore((state) => [state.userAuth], shallow);
  const { namedInsured } = useNewQuoteStore();
  const { customer } = namedInsured;

  return (
    <PanelBase name={isCustomerUser ? 'Customer' : 'Named Insured'} type={PanelBaseType.Closed} onEdit={onOpen}>
      <Grid container>
        <Grid size={{ xs: 12 }}>
          <Typography
            variant='bodySmall'
            sx={{
              display: 'inline',
              color: 'text.subdued',
            }}
          >
            Account Name
          </Typography>
          {customer ? (
            <Typography
              variant='bodySmall'
              sx={{
                fontWeight: 'bold',
                display: 'inline',
                marginLeft: '8px',
              }}
            >
              {customer.name}
              {customer.city && customer.state && !customer.businessAddress ? (
                <Typography
                  variant='bodySmall'
                  sx={{
                    display: 'inline',
                  }}
                >
                  {` - ${customer.city}, ${customer.state}`}
                </Typography>
              ) : null}
              {customer.businessAddress ? (
                <Typography
                  variant='bodySmall'
                  sx={{
                    display: 'inline',
                  }}
                >
                  {` - ${customer.businessAddress.city}, ${customer.businessAddress.state}`}
                </Typography>
              ) : null}
            </Typography>
          ) : null}
        </Grid>

        {/* Business Type Display */}
        {customer?.businessType && (
          <Grid size={{ xs: 12 }} sx={{ mt: 1 }}>
            <Typography
              variant='bodySmall'
              sx={{
                display: 'inline',
                color: 'text.subdued',
              }}
            >
              Business Type
            </Typography>
            <Typography
              variant='bodySmall'
              sx={{
                fontWeight: 'bold',
                display: 'inline',
                marginLeft: '8px',
              }}
            >
              {customer.businessType}
            </Typography>
          </Grid>
        )}
      </Grid>
    </PanelBase>
  );
};
